import { useQuery } from 'react-query';
import { queryPendingProspect } from './usePendingProspect.query';
import {
  QueryPendingProspectResponse,
  UsePendingProspectOptions,
  UsePendingProspectParams,
} from './usePendingProspect.types';

export const USER_INFOS_QUERY_KEY = 'USER_INFOS';

export const usePendingProspect = (
  params: UsePendingProspectParams,
  options?: UsePendingProspectOptions
) => {
  return useQuery<QueryPendingProspectResponse, Error>(
    [USER_INFOS_QUERY_KEY, params],
    () => queryPendingProspect(params),
    {
      ...options,
      retry: false,
      refetchOnWindowFocus: false,
    }
  );
};
